var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServingSize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1V4.5C1.5 5.05 1.95 5.5 2.5 5.5H4.5C4.76522 5.5 5.01957 5.39464 5.20711 5.20711C5.39464 5.01957 5.5 4.76522 5.5 4.5V1",
    stroke: "#3B1F8E",
    strokeWidth: 0.883112,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.50049 1V11",
    stroke: "#3B1F8E",
    strokeWidth: 0.883112,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.5V1C9.83696 1 9.20107 1.26339 8.73223 1.73223C8.26339 2.20107 8 2.83696 8 3.5V6.5C8 7.05 8.45 7.5 9 7.5H10.5ZM10.5 7.5V11",
    stroke: "#3B1F8E",
    strokeWidth: 0.883112,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServingSize);
export default __webpack_public_path__ + "static/media/servingSize.a1b984aabd6f1821243c88cdfda68935.svg";
export { ForwardRef as ReactComponent };